// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__7dIj9","footerText":"Footer_footerText__2yAU_"};